import dayjs, { Dayjs } from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import { PickersShortcutsItem } from '@mui/x-date-pickers/PickersShortcuts';
import { DateRange } from '@mui/x-date-pickers-pro/models';
import 'dayjs/locale/nb';
import { TFunction } from 'i18next';

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

export const shortcutsItems = (t: TFunction<'global', undefined>): PickersShortcutsItem<DateRange<Dayjs>>[] => [
  {
    label: t('datePicker.shortcuts.thisWeek'),
    getValue: () => {
      const today = dayjs();
      return [today.startOf('week'), today.endOf('week')];
    },
  },
  {
    label: t('datePicker.shortcuts.lastWeek'),
    getValue: () => {
      const today = dayjs().subtract(1, 'week');
      return [today.startOf('week'), today.endOf('week')];
    },
  },
  {
    label: t('datePicker.shortcuts.thisMonth'),
    getValue: () => {
      const today = dayjs();
      return [today.startOf('month'), today.endOf('month')];
    },
  },
  {
    label: t('datePicker.shortcuts.lastMonth'),
    getValue: () => {
      const today = dayjs().subtract(1, 'month');
      return [today.startOf('month'), today.endOf('month')];
    },
  },
  {
    label: t('datePicker.shortcuts.thisYear'),
    getValue: () => {
      const today = dayjs();
      return [today.startOf('year'), today.endOf('year')];
    },
  },
  {
    label: t('datePicker.shortcuts.lastYear'),
    getValue: () => {
      const today = dayjs().subtract(1, 'year');
      return [today.startOf('year'), today.endOf('year')];
    },
  },
  {
    label: t('datePicker.shortcuts.thisYearToDate'),
    getValue: () => {
      const today = dayjs();
      return [today.startOf('year'), today];
    },
  },
  {
    label: t('datePicker.shortcuts.lastYearToDate'),
    getValue: () => {
      const today = dayjs();
      const lastYearToday = today.subtract(1, 'year');
      return [lastYearToday.startOf('year'), lastYearToday];
    },
  },
  ...Array.from({ length: 6 }, (_, i) => {
    const start = dayjs()
      .startOf('year')
      .add(i * 2, 'month');
    const end = start.endOf('month').add(1, 'month').endOf('month');
    return {
      label: t('datePicker.shortcuts.treminate', { number: i + 1 }),
      getValue: () => [start, end] as [Dayjs, Dayjs],
    };
  }),
  ...Array.from({ length: 4 }, (_, i) => {
    const start = dayjs()
      .startOf('year')
      .add(i * 3, 'month');
    const end = start.add(2, 'month').endOf('month');
    return {
      label: t('datePicker.shortcuts.quarter', { number: i + 1 }),
      getValue: () => [start, end] as [Dayjs, Dayjs],
    };
  }),
  //   {
  //     label: t('datePicker.shortcuts.reset'),
  //     getValue: () => [null, null] as [null, null],
  //   },
];

export function findShortcutLabel(start: Dayjs | null, end: Dayjs | null, t: TFunction<'global'>): string | undefined {
  if (!start || !end) return undefined;

  const items = shortcutsItems(t);

  return items.find((item) => {
    const [s, e] = item.getValue({ isValid: () => true });
    if (!s || !e) return false;
    return start.isSame(s, 'day') && end.isSame(e, 'day');
  })?.label;
}

export const getDisplayDate = (startDate: Dayjs, endDate: Dayjs) => {
  return `${startDate.format('D. MMMM')} - ${endDate.format('D. MMMM, YYYY')}`;
};
